import React, { useContext } from "react";
import { StoreContext } from "../../../store/RootStore";
import { observer } from "mobx-react";
import withRouter from "../../../withRouter";
import config from "../../../config";
import { shouldShowComponent } from "../../../utils/componentVisibility";
import { Col, Form, Input, Select, DatePicker, Upload, Button } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import VehicleStore from "../../../store/VehicleStore";

const { Option } = Select;

const VehicleInfoAwtlProFormFields = (props) => {
  const shouldShow = shouldShowComponent(
    config.project,
    "VehicleInfoAwtlProFormFields",
  );

  const storeContext = useContext(StoreContext);
  const vehicleStore = new VehicleStore();

  if (!shouldShow) {
    return null;
  }
  return (
    <>
      <Col span={12} className="formColumnClass">
        {(props.isadmin.isadmin == -1 || props.isadmin.isadmin == 3) && (
        <>
          <Form.Item
            name="invoiceNo"
            label={
              <span>
                {storeContext.translate("_INVOICE_NUMBER_")}
                <span style={{ color: "red" }}>*</span>
              </span>
            }
            required={false}
            rules={[
              {
                required: true,
                message: `${storeContext.translate(
                  "_INVOICE_NUMBER_",
                )} ${storeContext.translate("_IS_REQUIRED_")}`,
              },
            ]}
            help={props.invoiceError || null}
            validateStatus={props.invoiceError ? "error" : ""}

          >
            <Input />
          </Form.Item>

          <Form.Item
            name="renewalPrice"
            label={
              <span>
                {storeContext.translate("_RENEWABLE_PRICE_")}
                <span style={{ color: "red" }}> *</span>
              </span>
            }
            required={false}
            rules={[
              {
                required: true,
                message: `${storeContext.translate(
                  "_RENEWABLE_PRICE_"
                )} ${storeContext.translate("_IS_REQUIRED_")}`,
              },
            ]}
          >
            <Input />
          </Form.Item>
        </>
        )}
         

        <Form.Item
          name="baseLocation"
          label={storeContext.translate("_BASE_LOCATION_")}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="capacity"
          label={storeContext.translate("_FUEL_CAPACITY_")}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="nofueltank"
          label={storeContext.translate("_NO_OF_FUEL_TANK_")}
        >
          <Select
            options={[
              { label: "1", value: 1 },
              { label: "2", value: 2 },
              { label: "3", value: 3 },
              { label: "4", value: 4 },
            ]}
          />
        </Form.Item>

        <Form.Item name="region" label={storeContext.translate("_REGION_")}>
          <Input />
        </Form.Item>
        <Form.Item
          name="lastBatteryDate"
          label={storeContext.translate("_LAST_BATTERY_CHANGE_")}
        >
          <DatePicker
            style={{ width: "100%", height: "40px" }}
            format="YYYY-MM-DD"
          />
        </Form.Item>
        {/* {console.log('loadsensor',props.loadSensor)} */}
        <Form.Item
            name="odometerReading"

            label={
              <span>
                {storeContext.translate("_FLEET_VEHICLE_VEHICLEDETAIL_ODOMETER_")}
                <span style={{ color: "red" }}> *</span>
              </span>
            } 
            required={false}
            rules={[
              {
                required: true,
                message: `${storeContext.translate(
                  "_FLEET_VEHICLE_VEHICLEDETAIL_ODOMETER_"
                )} ${storeContext.translate("_IS_REQUIRED_")}`,
              },
            ]}
          >
            <Input />
      </Form.Item>
      </Col>
      <Col span={12} className="formColumnClass">
        <Form.Item
          name="stationName"
          label={storeContext.translate("_STATION_")}
        >
          <Select
           className="select-dropdown"
            showSearch
            mode="tags"
            maxCount={1}
            options={
              props.stationlist?.map((val) => ({
                value: Number(val.id),
                label: val.station,
              })) || []
            }
            filterOption={(input, option) =>
              String(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            onChange={(value) => {
              if (value.length > 1) value.splice(0, value.length - 1);
            }}
          />
        </Form.Item>

        <Form.Item
          name="supervisorName"
          label={storeContext.translate("_SUPERVISOR_NAME_")}
        >
          <Select
            className="select-dropdown"
            showSearch
            mode="tags"
            maxCount={1}
            options={
              props.supervisorlist?.map((val) => ({
                value: Number(val.id),
                label: val.name,
              })) || []
            }
            filterOption={(input, option) =>
              String(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            onChange={(value) => {
              if (value.length > 1) value.splice(0, value.length - 1);
            }}
          />
        </Form.Item>

        <Form.Item
          name="customerName"
          label={storeContext.translate("_CUSTOMER_NAME_")}
        >
          <Select
            className="select-dropdown"
            showSearch
            mode="tags"
            maxCount={1}
            options={
              props.customerlist?.map((val) => ({
                value: Number(val.id),
                label: val.name,
              })) || []
            }
            filterOption={(input, option) =>
              String(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            onChange={(value) => {
              if (value.length > 1) value.splice(0, value.length - 1);
            }}
          />
        </Form.Item>

        <Form.Item
          name="assetTypeCustomName"
          label={storeContext.translate("_ASSET_TYPE_")}
        >
          <Select
          className="select-dropdown"
            showSearch
            mode="tags"
            maxCount={1}
            options={
              props.assettypelist?.map((val) => ({
                value: Number(val.id),
                label: val.name,
              })) || []
            }
            filterOption={(input, option) =>
              String(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            onChange={(value) => {
              if (value.length > 1) value.splice(0, value.length - 1);
            }}
          />
        </Form.Item>
        {/* {console.log(props.devicelist, "props.devicebrandlist")} */}
        {/* <Form.Item
          name="deviceBrandName"
          label={
            <span>
              {storeContext.translate("_DEVICE_BRAND_")}{" "}
              {props.This.loadSensor && props.waslVehicleField && (
                <span style={{ color: "red" }}> *</span>
              )}
            </span>
          }
          required={false}
          rules={[
            {
              required: props.This.loadSensor && props.waslVehicleField,
              message: `${storeContext.translate(
                "_DEVICE_BRAND_"
              )} ${storeContext.translate(
                "_IS_REQUIRED_"
              )}`,
            },
          ]}
        >
          <Select
            mode="combobox"
            options={
              props.devicelist?.length
                ? props.devicelist.map((val) => ({
                    value: val.id, // store name if typed
                    label: val.name,
                  }))
                : []
            }
            onChange={(value, option) => {
              if (value.length > 1) {
                value.splice(0, value.length - 1); // keep only latest
              }
            }}
          />
        </Form.Item> */}
        {(props.isadmin.isadmin == -1 || props.isadmin.isadmin == 3) && (
          <Form.Item
              name="deviceBrandName"
              
              label={
                <span>
                  {storeContext.translate("_DEVICE_BRAND_")}{" "}
                  <span style={{ color: "red" }}> *</span>
                </span>
              }
              required={false}
              rules={[
                {
                  required: true,
                  message: `${storeContext.translate("_DEVICE_BRAND_")} ${storeContext.translate("_IS_REQUIRED_")}`,
                },
              ]}
            >
            <Select
                className="select-dropdown"
                mode="tags"
                maxCount={1}
                showSearch
                allowClear
                placeholder={storeContext.translate("_DEVICE_BRAND_")}
                options={
                  props.devicelist?.map((val) => ({
                    value: Number(val.id),
                    label: val.name,
                  })) || []
                }
                filterOption={(input, option) =>
                  String(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                }
                onChange={(value) => {
                  if (value.length > 1) {
                    value.splice(0, value.length - 1);
                  }
                }}
              />
          </Form.Item>
        )}
        
        <Form.Item name="branch" label={storeContext.translate("_BRANCH_")}>
          <Input />
        </Form.Item>

        <Form.Item
          name="department"
          label={storeContext.translate("_DEPARTMENT_")}
        >
          <Input />
        </Form.Item>

        {/* <Form.Item
          name="ownership"
          label={storeContext.translate("_OWNERSHIP_")}
        >
          <Select
            options={[
              { label: "Own", value: "Own" },
              { label: "Rented", value: "Rented" },
            ]}
          />
        </Form.Item> */}

        {/*  */}
      </Col>
    </>
  );
};

export default observer(withRouter(VehicleInfoAwtlProFormFields));
